exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.onboarding {\n  position: relative;\n}\n.onboarding .bubble {\n  background: #3277cb;\n  border: 2px solid #00538c;\n  border-radius: 5px;\n  color: #fff;\n  margin-bottom: 15px;\n  position: relative;\n}\n.onboarding .bubble .bubble-text {\n  padding: 15px;\n}\n.onboarding .bubble::before {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: 28px;\n  right: auto;\n  top: auto;\n  bottom: -24px;\n  border: 12px solid;\n  border-color: #00538c transparent transparent;\n}\n.onboarding .bubble::after {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: 32px;\n  right: auto;\n  top: auto;\n  bottom: -16px;\n  border: 8px solid;\n  border-color: #3277cb transparent transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b23788aa","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Doctor/Onboarding.vue
// module id = 625
// module chunks = 1